import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Users, Info, Package, Instagram, Facebook, Menu, X } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { ReactComponent as LogoExtended } from '../../assets/logo-extended.svg';
import { ReactComponent as LogoTiny } from '../../assets/logo-tiny.svg';
import { useLocalization } from '../../utils/hooks/useLocalization'
import { UrlUtils } from "../../utils/urlUtils"
import social from "../../data/social"
import styles from './Navbar.module.css';

const Navbar = ({ isMobile }) => {
  console.log(window.scrollY);
  const location = UrlUtils.getSectionFromPath();
  const [isScrolled, setIsScrolled] = useState(window.scrollY > 0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useLocalization();

  const goTo = (page) => {
    const path = UrlUtils.buildLocalizedUrl(UrlUtils.getLanguageFromPath(), page)
    navigate(`${path}`);
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  const mobileGoTo = (page) => {
    setIsMobileMenuOpen(false)
    goTo(page)
  };


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <nav key={location} className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <div className={`${styles.brand} ${isScrolled || !UrlUtils.isHome() ? styles.brandScrolled : ''}`} onClick={() => mobileGoTo("home")}>
            {isMobile ? <LogoTiny /> : <LogoExtended />}
        </div>
        
        {/* Desktop Navigation */}
        <div className={styles.desktopNav}>
          <div onClick={() => goTo("artists")} className={`${styles.navLink} ${location === "artists" || location === "artist" ? styles.selected : {}}`}>
            <Users size={18} />
            {t("artists")}
          </div>
           <div onClick={() => goTo("story")} className={`${styles.navLink} ${location === "story" ? styles.selected : {}}`}>
            <Info size={18} />
            {t("aboutUs")}
          </div>
           <div onClick={() => goTo("products")} className={`${styles.navLink} ${location === "products" || location === "product" | location === "discover" ? styles.selected : {}}`}>
            <Package size={18} />
            {t("products")}
          </div>
        </div>


        {/* Social Links */}
        <div className={styles.socialLinks}>
          <a href={`https://www.instagram.com/${social.instagram}`} target='_blank' className={styles.socialLink}>
            <Instagram size={20} />
          </a>
          <a href={`https://www.facebook.com/${social.facebook}`} target='_blank' className={styles.socialLink}>
            <Facebook size={20} />
          </a>
          <a href={`https://t.me/${social.telegram}`} target='_blank' className={styles.socialLink}>
            <FontAwesomeIcon icon={faTelegram} style={{ fontSize: "20px" }} />
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={styles.mobileMenuBtn}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className={styles.mobileMenu}>
          <div className={styles.mobileSocialLinks}>
            <a href={`https://www.instagram.com/${social.instagram}`} target='_blank' className={styles.socialLink}>
              <Instagram size={20} />
            </a>
            <a href={`https://www.facebook.com/${social.facebook}`} target='_blank' className={styles.socialLink}>
              <Facebook size={20} />
            </a>
            <a href={`https://t.me/${social.telegram}`} target='_blank' className={styles.socialLink}>
              <FontAwesomeIcon icon={faTelegram} style={{ fontSize: "20px" }} />
            </a>
          </div>
          <a  onClick={() => mobileGoTo("artists")} className={styles.mobileNavLink}>
            <Users size={18} />
            Artists
          </a>
          <a  onClick={() => mobileGoTo("story")} className={styles.mobileNavLink}>
            <Info size={18} />
            Story
          </a>
          <a  onClick={() => mobileGoTo("products")} className={styles.lastMobileNavLink}>
            <Package size={18} />
            Products
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;